// museUI组件库  使用方法参照：https://muse-ui.org/#/zh-CN
import Vue from "vue";
// 引入MuserUI
import { Carousel, BottomNav, List, Button, Form, TextField } from "muse-ui";
import "muse-ui/dist/muse-ui.css";
import Helpers from "muse-ui/lib/Helpers";

Vue.use(Helpers);
Vue.use(BottomNav);
Vue.use(Carousel);
Vue.use(List);
Vue.use(Button);
Vue.use(Form);
Vue.use(TextField);

// 配置主题
import theme from "muse-ui/lib/theme";
theme.add(
  "softlink",
  {
    primary: "#4285f4",
    secondary: "inherit",
    success: "#4caf50",
    warning: "#ffeb3b",
    info: "#4285f4",
    background: {
      paper: "#fff",
      chip: "#e0e0e0",
      default: "#fff"
    }
  },
  "light"
);

theme.use("softlink");
